import React from 'react'
import styles from './MicrositeSslStatusBadge.module.css'
import { ShieldCheck, ShieldAlert, Clock, ShieldX } from 'lucide-react'

/**
 * MicrositeSslStatusBadge
 * SSL certificate state: PENDING / ACTIVE / FAILED / EXPIRED.
 *
 * Usage:
 *   <MicrositeSslStatusBadge value={domain.sslStatus} />
 */
const META = {
    ACTIVE:  { label: 'Active',  icon: ShieldCheck, tone: 'live' },
    PENDING: { label: 'Pending', icon: Clock,        tone: 'pending' },
    FAILED:  { label: 'Failed',  icon: ShieldX,      tone: 'failed' },
    EXPIRED: { label: 'Expired', icon: ShieldAlert,  tone: 'failed' }
}

const MicrositeSslStatusBadge = ({ value }) => {
    const meta = META[value] || META.PENDING
    const Icon = meta.icon
    return (
        <span className={`${styles.badge} ${styles[`tone_${meta.tone}`]}`}>
            <Icon size={11} />
            {meta.label}
        </span>
    )
}

export default MicrositeSslStatusBadge